module.exports = __webpack_public_path__ + "img/03.98093aa5.svg";